import getSrcSet from './getSrcSet';
export default getSrcSet;